import { useState } from 'react';

import { Icons } from '@/assets/icons/icons';
import { DropdownMenu } from '@/components/ui/dropdown-menu';

import { MergePersonDialog } from './merge-person-dialog';

import type { WikiPersonDetail } from '../people-wiki.types';

/** The ⋯ menu of a person's page. Its only action is merging, which keeps the user's own page, so that page has no menu. */
export const PersonMenu = ({ person }: { person: WikiPersonDetail }) => {
  const [isMerging, setIsMerging] = useState(false);

  if (person.isSelf) return null;

  return (
    <>
      <DropdownMenu.Root>
        <DropdownMenu.Trigger
          variant="ghost"
          aria-label={`Actions for ${person.name}`}
          className="size-8 justify-center p-0"
        >
          <Icons.moreHorizontal className="size-4" />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="end">
          <DropdownMenu.Item onSelect={() => setIsMerging(true)}>
            <Icons.merge className="size-3.5" />
            <span>Merge with…</span>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
      {isMerging && (
        <MergePersonDialog
          person={person}
          onClose={() => setIsMerging(false)}
        />
      )}
    </>
  );
};
